export default __webpack_public_path__ + "static/media/planeswalker.14ccef1a.svg";